import { Button, Flex } from "@instructure/ui";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import Skeleton from "react-loading-skeleton";
import GroupSelect from "../Selectors/GroupSelect";

const getPlanLabel = (plan) => plan.name || plan.cycle.name;

const Filter = ({
  filters,
  setFilters,
  handleLoadPlan,
  plans,
  loadedPlans,
}) => {
  const { t } = useTranslation();

  const handlePlanSelect = (selectedPlan) => {
    const planId = selectedPlan.id;
    setFilters({ ...filters, plan: planId });
  };

  const groupedPlans = useMemo(() => {
    const cycleMap = {};
    plans.forEach((plan) => {
      const cycleName = plan.cycle.name;
      if (!cycleMap[cycleName]) {
        cycleMap[cycleName] = [];
      }
      cycleMap[cycleName].push({ id: plan.id, label: getPlanLabel(plan) });
    });

    return Object.fromEntries(
      Object.keys(cycleMap)
        .sort((a, b) => a.localeCompare(b))
        .map((cycleName) => [
          cycleName,
          cycleMap[cycleName].sort((a, b) => a.label.localeCompare(b.label)),
        ])
    );
  }, [plans]);

  return (
    <Flex wrap="wrap" alignItems="end" gap="small" margin="0 0 small 0">
      <Flex.Item size="500px" padding="0 0 0 small">
        {loadedPlans ? (
          <GroupSelect
            id="assessment-plan-input"
            label={t("assessment.assessmentPlan")}
            options={groupedPlans}
            selectHandler={handlePlanSelect}
            selectedItemId={filters.plan}
            size="small"
            visibleOptionsCount={14}
          />
        ) : (
          <Skeleton
            count={1}
            style={{ width: "100%", height: 24, borderRadius: 5 }}
          />
        )}
      </Flex.Item>
      <Flex.Item>
        <Button
          size="small"
          id="search-outcomes-button"
          color="primary"
          onClick={() => handleLoadPlan(filters.plan)}
        >
          {t("search")}
        </Button>
      </Flex.Item>
    </Flex>
  );
};

export default Filter;
